import { cn } from './helpers';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='skeleton'
      className={cn('bg-primary-900/5 animate-pulse rounded-md', className)}
      {...props}
    />
  );
}

export { Skeleton };
